import { useState } from 'react';
const SideBarTable = ({ tableObjectData }) => {
    const [showFullValue, setShowFullValue] = useState({});

    const handleValueClick = (key) => {
        setShowFullValue({ ...showFullValue, [key]: !showFullValue[key] });
    };

    return (
        <div className='mt-4 text-[10px] md:text-[10px] 2xl:text-[12px] h-[80vh] overflow-y-auto overflow-x-auto scrollbar-width'>
            < table className="w-full table-auto overflow-scroll" >
                <thead className="sticky top-0 bg-secondaryBg border border-dividerLines">
                    <tr className=' divide-x divide-dividerLines'>
                        <th className='p-1'>Property </th>
                        <th className='p-1'>Value</th>
                    </tr>
                </thead>
                <tbody className=' '>
                    {Object.keys(tableObjectData).map((key) => {

                        const value = tableObjectData[key];
                        const showFull = showFullValue[key];
                        let displayValue = JSON.stringify(value);

                        return (
                            <tr key={key} className="">
                                <td className="px-2 border border-dividerLines">{key}</td>
                                <td
                                    className={`text-clip h-full border font-medium border-dividerLines px-2 ${displayValue.length > 22 ? 'cursor-pointer' : ' cursor-default'}`}
                                    onClick={() => {
                                        if (displayValue.length > 22) {
                                            handleValueClick(key)
                                        }
                                    }}
                                    title={displayValue}
                                >
                                    {displayValue.length > 14 && showFull ? (
                                        <p>{displayValue}</p>
                                    ) : (
                                        <div className=' flex gap-2 tracking-tight'>
                                            <p>{displayValue.slice(0, 14)}</p>
                                            {displayValue.length > 20 && (
                                                <p className='text-alertSuccess'>... View More</p>
                                            )}
                                        </div>
                                    )}
                                    {/* {displayValue.length > 20 && showFull ? displayValue : displayValue.slice(0, 22) + `${<p className=' text-alertSuccess'>...show More</p>}`} */}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table >
        </div >
    );
};

SideBarTable.propTypes = null;

export default SideBarTable;
